import { useMemo } from "react"

import { isProjectRoom } from "shared/types/Project"
import { Room } from "shared/types/Room"
import { SelectOption } from "shared/types/Select"

import { useProjectData } from "entities/projects/api/useProjectData"

interface UseFloorRoomOptionsArgs {
  projectID: string | null
}

export function useFloorRoomOptions({ projectID }: UseFloorRoomOptionsArgs) {
  const { project, isLoading: isLoadingChildren } = useProjectData(
    projectID,
    true
  )

  const roomOptions: SelectOption<string>[] = useMemo(() => {
    if (!project?.children) {
      return []
    }

    const availableRooms = project.children.filter(isProjectRoom) as Room[]

    return availableRooms.map(room => ({
      key: room.id,
      value: room.id,
      label: `${room.number || room.label || ""}`
    }))
  }, [project?.children, projectID])

  return {
    isLoading: isLoadingChildren,
    roomOptions
  }
}
